const alertContainer = document.querySelector('.block-alert-top');

//Add height to body for other fixed/absolute elements
if (alertContainer) {
	const alertObserver = new ResizeObserver((entries) => {
		entries.forEach(() => {
			const alertContainerHeight = alertContainer.offsetHeight;

			document.body.style.setProperty(
				'--alert-height',
				`${alertContainerHeight}px`
			);
		});
	});

	alertObserver.observe(alertContainer);
}
